import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import Datetime from 'react-datetime';

import { Label, FormFeedback } from 'reactstrap';

import moment from 'moment';

class ModalAHistorico extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitudes: [],
            año: moment(),
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            solicitudes: [],
            año: moment(),
        })
    }
    
    getData(){
        const { solicitudes, año } = this.state;

        let añoAux = año.format('YYYY');

        return {solicitudes, año: añoAux}
    }

    setSelects(data) {

    }

    onValidation(){
        const { solicitudes, año } = this.state;

        if((typeof(año)!='string') && (solicitudes.length>0)){
            return true;
        }

        return false;
    }

    onOpen = () => {
        let selectedRows = this.props.rows();
        if(selectedRows.length>0){
            let solicitudes = [];
            selectedRows.forEach((row)=>{
                solicitudes.push(row.plan__solicitud_id);
            })
            this.setState({
                solicitudes: solicitudes,
            })
        }
    }


    render() {
        return (
            <ParadigmaModal
                // getUrl={api.proyectos.presupuesto.edit}
                postUrl={api.proyectos.solicitudes.cambiarahistorico}
                onSubmit={(e) => {this.props.onSubmit(e)}}
                id={this.props.id}
                successMessage={"El Presupuesto ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Presupuesto ya se encuentra cerrado."}
                title={"Pasar Proyectos a Historicos"}
                buttonTitle={"Pasar Proyectos a Historicos"}
                // buttonIcon={"fa fa-history fa-lg"}
                buttonIcon={"fa fa-indent fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}
                onOpen={() => this.onOpen()}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                multiselect={true}
                backdropToggle={true}
            >
                {this.props.multiSelectIDs() ? 
                <div className="ui-form">
                    <section className="ui-section-block">
                        <div className="ui-section-banner">
                            <span className="ui-icon-pill"><i className="ti ti-clock" aria-hidden="true"></i></span>
                            <p>Proyectos seleccionados</p>
                        </div>
                        <div className="ui-scroll-list">
                            <table className="ui-table">
                                <thead>
                                    <tr>
                                        <th width={"120px"}>Codigo</th>
                                        <th>Nombre</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.rows().map((e, i)=>
                                    <tr key={i}>
                                        <td>
                                            {(e.plan__solicitud__codigo) ? (e.plan__solicitud__codigo) : ''}
                                        </td>
                                        <td>
                                            {(e.plan__solicitud__nombre) ? (e.plan__solicitud__nombre) : ''}
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </section>
                    <section className="ui-section-block ui-section-span-2 mt-3">
                        <p className="ui-section-label">Periodo historico</p>
                        <div className="ui-row-2">
                            <div className="ui-field ui-field-compact">
                                <Label>Año</Label>
                                <Datetime
                                    className="input-year"
                                    dateFormat="YYYY"
                                    inputProps={{ maxLength: 4 }}
                                    defaultValue={moment()}
                                    closeOnSelect={true}
                                    onChange={(data) => this.setState({año: data})}
                                />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
                :
                    <div className="ui-form">
                        <div className="ui-alert ui-alert-warning mb-0">Debe seleccionar una fila.</div>
                    </div>
                }
            
            </ParadigmaModal>
        );
    }
}

export default ModalAHistorico;



// WEBPACK FOOTER //
// ./src/views/ProyectosHistoricos/ModalAHistorico.js